export interface URLMapEntry<TParams extends readonly unknown[]> {
  path: (...args: TParams) => string;
}

interface URLMap {
  login: URLMapEntry<[]>;
  checkout: URLMapEntry<[]>;
  eventPurchase: URLMapEntry<[string]>;
  expressCheckout: URLMapEntry<[]>;
  productPurchase: URLMapEntry<[string]>;
  calendarLegacy: URLMapEntry<[string]>;
  calendar: URLMapEntry<[string]>;
  basket: URLMapEntry<[]>;
  membership: URLMapEntry<[string]>;
}

export const URL_MAP = {
  login: {
    path: () => "/accounts/login/",
  },
  checkout: {
    path: () => "/widget/tickets/events/checkout/",
  },
  eventPurchase: {
    path: (slug: string) => `/widget/tickets/events/purchase/${slug}/`,
  },
  expressCheckout: {
    path: () => "/widget/tickets/events/express-checkout/",
  },
  productPurchase: {
    path: (id: string) => `/widget/tickets/products/purchase/${id}/`,
  },
  calendarLegacy: {
    path: (id: string) => `/widget/tickets/events/calendar/${id}/`,
  },
  calendar: {
    path: (id: string) => `/widget/calendar/venue/${id}/`,
  },
  basket: {
    path: () => "/widget/tickets/events/cart/",
  },
  membership: {
    path: (id: string) => `/widget/tickets/memberships/${id}/`,
  },
} satisfies URLMap;
